// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';
import './Skeleton.css';

export interface SkeletonProps {
  variant?: 'line' | 'paragraph' | 'header' | 'image';
  lines?: number;
  width?: string;
  height?: string;
  className?: string;
  style?: React.CSSProperties;
}

export function Skeleton({
  variant = 'line',
  lines = 3,
  width,
  height,
  className = '',
  style,
}: SkeletonProps) {
  const inlineStyle: React.CSSProperties = {
    ...(width ? { width } : {}),
    ...(height ? { height } : {}),
    ...style,
  };

  if (variant === 'paragraph') {
    const lineCount = lines > 0 ? lines : 3;
    return (
      <div
        className={['fin-skeleton', 'fin-skeleton--paragraph', className].filter(Boolean).join(' ')}
        style={style}
      >
        {Array.from({ length: lineCount }).map((_, index) => (
          <div
            key={index}
            className="fin-skeleton fin-skeleton--line"
            style={index === lineCount - 1 ? { width: '60%' } : undefined}
          />
        ))}
      </div>
    );
  }

  const classes = [
    'fin-skeleton',
    `fin-skeleton--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <div className={classes} style={inlineStyle} />;
}
